// import { useEffect } from "react";

// import { notification } from "antd";

// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//   const token = localStorage.getItem("jwt");

//   useEffect(() => {
//     if (!token) {
//       notification.warning({
//         message: "Authentication Required",
//         description: "Please log in to access this page.",
//         placement: "topRight",
//       });
//     }
//   }, [token]);

//   return token ? children : <Navigate to="/login" />;
// };

// export default PrivateRoute;




import { useEffect, useRef } from "react";
import { notification } from "antd";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("jwt");
  const hasNotifiedRef = useRef(false);

  useEffect(() => {
    if (!token && !hasNotifiedRef.current) {
      notification.warning({
        message: "Authentication Required",
        description: "Please log in to access this page.",
        placement: "topRight",
      });
      hasNotifiedRef.current = true;
    }
  }, [token]);

  return token ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
